let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("amDgn")).then(() => parcelRequire('eFvlq'));